import { render, staticRenderFns } from "./ScholarshipItem.vue?vue&type=template&id=7c3f5060&scoped=true&"
import script from "./ScholarshipItem.vue?vue&type=script&lang=js&"
export * from "./ScholarshipItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3f5060",
  null
  
)

export default component.exports